/*
  作者：bai.zhiming
  时间：2017-03-10
  描述：采编中心-app渠道新闻稿编辑器预览功能
*/
"use strict";
angular.module("appUeditorPreviewModule", [])
    .controller("appUeditorPreviewCtrl", ["$scope", 'previewUrl', "$sce", "$modalInstance", function($scope, previewUrl, $sce, $modalInstance) {
        init();

        function init() {
            $scope.previewUrl = $sce.trustAsResourceUrl(previewUrl);
        }
        $scope.close = function() {
            $modalInstance.dismiss();
        };
    }]);
